import { connect } from 'react-redux';
import UserForm from './index';
import { mapDispatchToProps, mapStateToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
